import axios from 'axios';
import SiteConfig from './positiva';
import { getAccessToken } from '../utils/auth';

const instance = axios.create({
    baseURL: SiteConfig.BASE_URL,
});

const getGroupedProducts = () => {
    return instance.get(`/products/`, {
        headers: {
            'Authorization': `Token ${getAccessToken()}`,
        }
    })
}

const getProductsByCompany = (companyId) => {
    return instance.get(`/products/by-company?company_id=${companyId}`, {
        headers: {
            'Authorization': `Token ${getAccessToken()}`,
        }  
    })
}

const createQuotation = (data) => {
    return instance.post(`/quotation/create`, data, {
        headers: {
            'Authorization': `Token ${getAccessToken()}`,
        }
    })
}

const getProductDataDetail = (code) => {
    return instance.get(`/quotation/` + code + `/detail`, {
        headers: {
            'Authorization': `Token ${getAccessToken()}`,
        }
    })
}

const updateProductData = (id, data) => {
    return instance.post(`/quotation/` + id + `/update`, data, {
            headers: {
                'Authorization': `Token ${getAccessToken()}`,
            }
    })
}

const addCommentMessage = (id, idComment, data) => {
    return instance.post(`/quotation/` + id + `/comment/` + idComment + `/message`, data, {
            headers: {
                'Authorization': `Token ${getAccessToken()}`,
            }
    })
}

const getCompanies = () => {
    return instance.get(`/companies`, {
        headers: {
            'Authorization': `Token ${getAccessToken()}`,
        }
    })
}

export {
    addCommentMessage,
    createQuotation,
    getCompanies,
    getGroupedProducts,
    getProductDataDetail,
    updateProductData,
    getProductsByCompany
}
